module.exports = __webpack_public_path__ + "static/media/saved-template-list.69102292.png";